module.exports = __webpack_public_path__ + "static/media/videocam_off.0739802d.svg";